import React, { Component } from 'react';
import jwtDecode from 'jwt-decode';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { SHA256 } from 'crypto-js';

import { getContent, getErrorCode } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../../constants/roleCategoryConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import Alert from '../../../components/Alert/Alert';
import IconOpenedEye from '../../../assets/icons/IconOpenedEye';
import IconClosedEye from '../../../assets/icons/IconClosedEye';
import IconGroChat from '../../../assets/icons/IconGroChat';
import OutsideLogo from '../../../components/Common/OutsideLogo';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';
import { redirectUri, openWindow } from '../../../util/redirectUtil';
import { baseUrl, grochatPwaUrl, localUrl } from '../../../config/serviceConfig';
import { GroChatVoipContext } from '../../../components/GroChatVoipProvider/GroChatVoipProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

class Login2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isGrochatAuthenticated: false,
            username: '',
            password: '',
            authorization: '',
            code_verifier: '',
            token: '',
            refreshToken: '',
            hasGrochatAccount: false,
            detailUser: '',
            showPassword: false,
            isSubmitted: false,
            showSuccessAlert: false,
            showErrorVerify: false,
            showErrorConnect: false,
            showErrorForbidden: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getGrochatInternalToken = data => {
        const popupWindow = (url, windowName, win, w, h) => {
            const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
            const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
            return win.open(
                url,
                windowName,
                `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
            );
        };

        API_AUTHENTICATION.getGrochatInternalToken()
            .then(res => {
                localStorage.setItem('requestId', Math.random().toString(36).substring(2));
                localStorage.setItem('token', this.state.token);

                let grochatUri = '';
                let token = getContent(res);
                let requestIdEncrypted = SHA256(localStorage.getItem('requestId'));
                let redirectUri = '';
                let resourceId = 'care';
                let cancelUri = '';
                let grochatBaseUrl = localUrl ? localUrl : baseUrl;

                if (data) {
                    grochatUri = `${grochatPwaUrl}/migrations`;
                    redirectUri = `${grochatBaseUrl}/grochat-migration?token=${this.state.token}`;
                    cancelUri = `${grochatBaseUrl}/grochat-cancel`;
                    let resourceName = 'NexCare';
                    let authUserId = data.user_id;
                    let username = data.username;
                    let userProfiling = 'C';

                    let linkMigrateUser = `${grochatUri}?token=${token}&request_id=${requestIdEncrypted}&success=${redirectUri}&resource_name=${resourceName}&resource_id=${resourceId}&cancel=${cancelUri}&auth_user_id=${authUserId}&userName=${username}&user_profiling=${userProfiling}`
                    return popupWindow(linkMigrateUser, '', window, 500, 700);
                }

                grochatUri = `${grochatPwaUrl}/login`;
                redirectUri = `${grochatBaseUrl}/grochat-login`;
                cancelUri = `${grochatBaseUrl}/grochat-cancel`;
                let linkRedirectUri = `${grochatUri}?token=${token}&request_id=${requestIdEncrypted}&redirect_uri=${redirectUri}&resource_id=${resourceId}&cancel=${cancelUri}`;
                return popupWindow(linkRedirectUri, '', window, 500, 700);
            }).catch(err => {
                console.log(err);
            })
    }

    postDataAuthorize = () => {
        API_AUTHENTICATION.postDataAuthorize()
            .then(async res => {
                if (this._isMounted) {
                    await this.setState({
                        authorization: res.headers.authorization,
                        code_verifier: res.headers['code_verifier']
                    });
                    this.postDataVerify();
                }
            }).catch(err => {
                this.setState({
                    showErrorConnect: true,
                    isSubmitted: false,
                    loading: false
                });
            })
    }

    postDataVerify = () => {
        if (this.state.authorization === '' && this.state.code_verifier === '') {
            this.setState({ showErrorConnect: true });
            return setTimeout(() => this.setState({ showErrorConnect: false }), 1500);
        }

        const verify = {
            username: this.state.username,
            password: this.state.password
        };

        API_AUTHENTICATION.postDataVerify(verify, this.state.authorization)
            .then(res => {
                this.setState({
                    showErrorConnect: false,
                    showErrorVerify: false
                })
                this.postDataLogin(res.headers['x-nexcode'], this.state.code_verifier);
            }).catch(err => {
                if (getErrorCode(err) === 'IS_USER_ACTIVE') {
                    return this.setState({
                        showErrorUserInactive: true,
                        isSubmitted: false,
                        loading: false
                    });
                }
                this.setState({
                    showErrorVerify: true,
                    isSubmitted: false,
                    loading: false
                });
            })
    }

    postDataLogin = (authorizationCode, codeVerifier) => {
        const login = {
            authorization_code: authorizationCode,
            code_verifier: codeVerifier
        };

        API_AUTHENTICATION.postDataLogin(login)
            .then(res => {
                const token = res.headers.authorization;
                const refreshToken = getContent(res).refresh_token;
                const hasGrochatAccount = getContent(res).has_grochat_account_id;
                if (jwtDecode(token).resource.split(' ').includes('care') === true && token !== null) {
                    this.setState({
                        token,
                        refreshToken,
                        hasGrochatAccount
                    }, () => {
                        this.postDataUser();
                    })
                }
            }).catch(err => {
                if (getErrorCode(err) === 'IS_USER_ACTIVE') {
                    return this.setState({
                        showErrorUserInactive: true,
                        isSubmitted: false,
                        loading: false
                    });
                }

                if (getErrorCode(err) === 'E-4-CARE-SRV-018') {
                    return this.setState({
                        showConfirmMigrationAlert: false,
                        showErrorAlert: true,
                        isSubmitted: false,
                        loading: false
                    });
                }

                if (err.response?.status === 401) {
                    this.setState({
                        showErrorForbidden: true,
                        isSubmitted: false,
                        loading: false
                    });
                }
                if (err.response?.status === 500) {
                    this.setState({
                        showErrorConnect: true,
                        isSubmitted: false,
                        loading: false
                    });
                }
            })
    }

    postDataUser = () => {
        const detailUser = {
            username: this.state.username
        }

        API_AUTHENTICATION.postDetailUser(detailUser, this.state.token)
            .then(res => {
                localStorage.removeItem('dashboardPrincipal');
                localStorage.removeItem('dashboardManager');
                localStorage.removeItem('dashboardLead');
                localStorage.removeItem('dashboardOfficer');
                this.setState({
                    detailUser: getContent(res)
                }, () => {
                    if (this.state.detailUser.level === '' || this.state.detailUser.level === ROLE_CATEGORY_CONSTANT.DISTRIBUTOR) {
                        return this.setState({
                            showErrorForbidden: true,
                            isSubmitted: false,
                            loading: false
                        });
                    }
                    if (!this.state.hasGrochatAccount) {
                        return this.setState({
                            loading: false,
                            showConfirmMigrationAlert: true
                        });
                    }
                    this.setState({ showSuccessAlert: true, loading: false, showConfirmMigrationAlert: false });
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.handleLogin(this.state.token, this.state.refreshToken, this.state.detailUser);
                        redirectUri(this.state.detailUser, this.props.history);
                    }, 1500);
                })
            })
    }

    handleGrochatMigration = isMigrate => {
        if (isMigrate) return this.getGrochatInternalToken(this.state.detailUser)

        this.setState({ showSuccessAlert: true, loading: false, showConfirmMigrationAlert: false });
        setTimeout(() => {
            this.setState({ showSuccessAlert: false });
            this.props.handleLogin(this.state.token, this.state.refreshToken, this.state.detailUser);
            redirectUri(this.state.detailUser, this.props.history);
        }, 1500);
    }

    handleAlreadyLogin = () => {
        if (localStorage.getItem('isGrochatAuthenticated') === 'true') {
            const userDetail = this.props.userDetail || this.state.detailUser;
            if (!userDetail) {
                if (sessionStorage.getItem('grochatAuthSyncReloaded') === 'true') {
                    localStorage.removeItem('isGrochatAuthenticated');
                    sessionStorage.removeItem('grochatAuthSyncReloaded');
                    return;
                }

                sessionStorage.setItem('grochatAuthSyncReloaded', 'true');
                window.location.reload();
                return;
            }

            sessionStorage.removeItem('grochatAuthSyncReloaded');
            let grochatBaseUrl = localUrl ? localUrl : baseUrl;
            window.location.href = `${grochatBaseUrl}${openWindow(userDetail)}`;
        }
    }

    handleAccountMigration = () => {
        if (localStorage.getItem('isGrochatAccountMigrated')) {
            localStorage.removeItem('isGrochatAccountMigrated');
            this.setState({ showConfirmMigrationAlert: false });
            window.location.reload();
        }
    }

    removeAttribute = e => {
        e.target.removeAttribute('readonly');
    }

    componentDidMount() {
        this._isMounted = true;

        if (this.props.login || this.props.token !== null) {
            return redirectUri(this.props.userDetail, this.props.history);
        }

        this.intervalLogin = setInterval(() => {
            this.handleAlreadyLogin();
        }, 1000);

        this.intervalMigration = setInterval(() => {
            this.handleAccountMigration();
        }, 1000);
    }

    componentWillUnmount() {
        this._isMounted = false;

        clearInterval(this.intervalLogin);
        clearInterval(this.intervalMigration);
    }

    /**
     * @returns {React.ContextType<GroChatVoipContext>} 
     */
    getGroChatVoipContext = () => {
        return this.context;
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({ isSubmitted: true, loading: true });
        if (!this.state.isSubmitted) {
            this.postDataAuthorize();
        }
    }

    render() {
        return (
            <div className="w-screen h-screen bg-white relative nexcare-login-background p-52">
                <LoadingLoader show={this.state.loading} />
                <OutsideLogo />
                <div className="flex items-center flex-row-reverse h-full text-center">
                    <form onSubmit={this.handleSubmit} className="text-gray-600">
                        <p className="font-bold" style={{ fontSize: "3.5rem" }}>Selamat Datang</p>
                        <div className="quote font-medium mt-5">
                            <p>Tim bukan sekelompok orang yang bekerja sama.</p>
                            <p>Tim adalah sekelompok orang yang saling percaya.</p>
                            <p>-Simon Sinek</p>
                        </div>
                        <div className="h-16 flex items-center">
                            {this.state.showErrorVerify && <p className="text-darkred font-medium">Username / Password salah!</p>}
                            {this.state.showErrorConnect && <p className="text-darkred font-medium">Tidak terhubung dengan server!</p>}
                        </div>
                        <input
                            type="text"
                            id="tslusername"
                            name="username"
                            placeholder="Username / Email"
                            autoComplete="off"
                            readOnly
                            onFocus={this.removeAttribute}
                            onChange={this.handleChange}
                            className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                        />
                        <div className="relative">
                            <input
                                type={this.state.showPassword ? "text" : "password"}
                                id="tslpassword"
                                name="password"
                                placeholder="Kata Sandi"
                                autoComplete="off"
                                onChange={this.handleChange}
                                className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                            />
                            <div className="absolute right-5 top-1/2 transform -translate-y-1/2">
                                {
                                    this.state.showPassword
                                        ? <div id="btnshowpassword" onClick={() => this.setState({ showPassword: false })} className="cursor-pointer">
                                            <IconOpenedEye />
                                        </div>
                                        : <div id="btnshowpassword" onClick={() => this.setState({ showPassword: true })} className="cursor-pointer">
                                            <IconClosedEye />
                                        </div>
                                }
                            </div>
                        </div>
                        <button type="submit" id="btnlogin" className="bg-darkblue w-full h-16 text-white outline-none rounded mt-10">Masuk</button>
                        <div className="font-medium py-5">
                            <Link to={ROUTER_CONSTANT.RESET_PASSWORD} className="text-gray-500" id="btnforgetpassword">Lupa kata sandi?</Link>
                        </div>
                        <button type="button" id="btnlogingrochat" className="border-2 border-gray-300 rounded flex justify-center items-center space-x-2 py-2 px-5 w-full" onClick={() => this.getGrochatInternalToken()}>
                            <IconGroChat />
                            <span className="text-lg text-nexcarepurple2 font-medium">Masuk dengan Akun Grochat</span>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </form>
                </div>
                <Alert show={this.state.showErrorAlert} icon="warning" title="Akun Anda telah login di perangkat lain, silahkan logout terlebih dahulu!" close={() => this.setState({ showErrorAlert: false })} ok />
                <Alert show={this.state.showErrorForbidden} icon="warning" title="Anda tidak memiliki akses!" close={() => this.setState({ showErrorForbidden: false })} ok />
                <Alert show={this.state.showErrorUserInactive} icon="warning" title="User Anda sudah tidak aktif, Silahkan hubungi Customer Service untuk diaktifkan kembali!" close={() => this.setState({ showErrorUserInactive: false })} ok />
                <Alert show={this.state.showConfirmMigrationAlert} icon="warning" button={true} title="Apakah Anda ingin melakukan migrasi akun?" close={() => this.handleGrochatMigration(false)} submit={() => this.handleGrochatMigration(true)} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil masuk NexCare!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

Login2.contextType = GroChatVoipContext;

const mapStateToProps = (state) => {
    return {
        login: state.authentication.login,
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: (token, refreshToken, userDetail) => dispatch({ type: ActionType.IS_LOGIN, payload: { token, refreshToken, userDetail } })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login2));
